import axios from "axios";
import {CASHIER_BOX_API, CASHIER_SETTING_API} from "../../config";
import Cache from "../cache";
//import * as assert from "assert";

async function findSetting() {
    // const cachedCustomSetting = await Cache.get("CustomSetting");
    // if(cachedCustomSetting) return cachedCustomSetting;
    return axios
        .get(CASHIER_SETTING_API)
        .then(response => {
            const setting = response.data.setting;
            //Cache.set("CustomSetting", setting);
            return response.data.setting;
        });
}

async function getUSBCashBox() {
    return axios
        .get(CASHIER_BOX_API + "/getUSBCashBox")
        .then(response => {
            //const setting = response.data.usbCashBox;
            return response.data.usbCashBox;
        });
}

async function getCDFCashBox() {
    return axios
        .get(CASHIER_BOX_API + "/getCDFCashBox")
        .then(response => {
            //const setting = response.data.cdfCashBox;
            return response.data.cdfCashBox;
        });
}

function storeCashIn(cashIn){

    console.log(cashIn);

    return axios.post(CASHIER_BOX_API + "/storeCashIn", {...cashIn, date : cashIn.created_at})
        .then(async response => {
            return response;
        });
}

function storeCashOut(cashOut){
    return axios.post(CASHIER_BOX_API + "/storeCashOut", {...cashOut, date : cashOut.created_at})
        .then(async response => {
            return response;
        });
}



async function findRapportCashIns(){
    return axios.get(CASHIER_BOX_API + "/cash/in")
        .then(response => {
            return response.data.cashIns;
        });
}

async function findRapportCashOutsCDF(){
    //const cachedCashOutsCDF = await Cache.get("CashierCashOutsCDF");
    //if(cachedCashOutsCDF) return cachedCashOutsCDF;
    return axios.get(CASHIER_BOX_API + "/cash/out/cdf")
        .then(response => {
            //const cashOuts = response.data.cashOuts;
            //Cache.set("CashierCashOutsCDF", cashOuts);
            return response.data.cashOuts;
        });
}

async function findRapportCashOutsUSD(){
    return axios.get(CASHIER_BOX_API + "/cash/out/usd")
        .then(response => {
            return response.data.cashOuts;
        });
}

async function getCashAccounts(){
    return axios.get(CASHIER_BOX_API + "/accounts")
        .then(response => {
            return response.data.accounts;
        });
}

/**
 * Cash Account
 */

async function findCashAccounts(){
    return axios.get(CASHIER_BOX_API + "/cashAccounts")
        .then(response => {
            return response.data.cashAccounts;
        });
}

function storeCashAccount(cashAccount){
    return axios.post(CASHIER_BOX_API + "/cashAccounts/store", cashAccount)
        .then(async response => {
            return response;
        });
}

async function findOneCashAccount(id) {
    return axios
        .get(CASHIER_BOX_API + "/cashAccounts/" + id)
        .then(response => {
            return response.data.cashAccount;
        });
}

async function findOneCashOut(id) {
    return axios
        .get(CASHIER_BOX_API + "/findOneCashOut/" + id)
        .then(response => {
            return response.data.cashOut;
        });
}

async function findOneCashIn(id) {
    return axios
        .get(CASHIER_BOX_API + "/findOneCashIn/" + id)
        .then(response => {
            return response.data.cashIn;
        });
}




/**
 * Cash Account
 */

async function findComptes(){
    return axios.get(CASHIER_BOX_API + "/comptes")
        .then(response => {
            return response.data.comptes;
        });
}

function storeComptes(compte){
    return axios.post(CASHIER_BOX_API + "/storeComptes", compte)
        .then(async response => {
            return response;
        });
}

async function findOneCompte(id) {
    return axios
        .get(CASHIER_BOX_API + "/comptes/" + id)
        .then(response => {
            return response.data.compte;
        });
}


export default {
    findRapportCashOutsCDF,
    findRapportCashOutsUSD,
    findRapportCashIns,
    getCashAccounts,
    getUSBCashBox,
    getCDFCashBox,
    findSetting,
    storeCashIn,
    storeCashOut,

    findOneCashAccount,
    findOneCashOut,
    findOneCashIn,
    findCashAccounts,
    storeCashAccount,

    findComptes,
    storeComptes,
    findOneCompte,
};